import React, { useState } from 'react'
import { useStateValue } from '@State'
import { DeductionInputs } from './DeductionInputs'
import { canvasConnect as endpoints } from '@URLS'
import { client } from '@Utils'
import { toast } from '@CommonComponents/toast'

export const DefaultLatePolicyForm = () => {
  const [currentState] = useStateValue()
  const [selectedOption, setOption] = useState('flag')
  let coursenum = window.location.pathname.split('/')[3]

  const handleChange = (func, value) => {
    func(value)
  }

  const handleFormSubmit = async e => {
    let data = {
      coursenum: coursenum,
      policy: selectedOption,
      deductions: currentState.defaultDeductions,
    }
    e.preventDefault()
    try {
      var resp = await client.post(endpoints.postDefaultLatePolicy(), data)
      if (resp.status === 204) {
        toast.success("Successfully added a default late policy")
     }
    } catch (err) {
      toast.error(`There was an error trying to save the default late policy. ${err}`)
    }
  }

  return (
    <div className="bg-white px-5 pb-4 pt-1 rounded">
      <h4>Default Late Policy</h4>
      <form className="ml-3">
        <div className="form-check">
          <label className="d-flex">
            <input
              type="radio"
              name="react-tips"
              value="prevent"
              checked={selectedOption === 'prevent'}
              onChange={e => handleChange(setOption, e.target.value)}
              className="form-check-input mr-2"
            />
            Prevent any submissions after the due date
          </label>
        </div>
        <div className="form-check">
          <label className="d-flex">
            <input
              type="radio"
              name="react-tips"
              value="flag"
              checked={selectedOption === 'flag'}
              onChange={e => handleChange(setOption, e.target.value)}
              className="form-check-input mr-2"
            />
            Flag the late submissions
          </label>
        </div>
        <div className="form-check">
          <label className="d-flex">
            <input
              type="radio"
              name="react-tips"
              value="deduct"
              checked={selectedOption === 'deduct'}
              onChange={e => handleChange(setOption, e.target.value)}
              className="form-check-input mr-2"
            />
            Assign point deductions
          </label>
          {selectedOption === 'deduct' && <DeductionInputs />}
        </div>
        <div className="form-group">
          <button
            className="btn btn-myed btn-secondary btn-secondary-myed mt-5"
            type="submit"
            onClick={handleFormSubmit}
          >
            Save Default Late Policy
          </button>
        </div>
      </form>
    </div>
  )
}
